/* ============================================================
   BLOOMS — storefront interactivity
   Cart drawer · AJAX cart · variant selection · AOV mechanics
   Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- helpers ---------- */
  function formatMoney(amount, currency) {
    // amount is a whole-currency number (e.g. 634). Store is AED by default.
    var n = Math.round(amount).toLocaleString('en-US');
    return (currency || 'AED') + ' ' + n;
  }

  function postJSON(url, body) {
    return fetch(ROOT.replace(/\/$/, '') + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetch(ROOT.replace(/\/$/, '') + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ============================================================
     CART DRAWER
     ============================================================ */
  var drawer = $('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function refreshDrawer(openAfter) {
    return fetch(ROOT.replace(/\/$/, '') + '/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-contents]');
        var live = $('[data-cart-contents]');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
        updateCartCounts();
        if (openAfter) openDrawer();
      });
  }

  function updateCartCounts() {
    getCart().then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    });
  }

  /* delegated clicks for the whole document */
  document.addEventListener('click', function (e) {
    var t = e.target;

    // open / close drawer
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    // remove line item
    var removeBtn = t.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeLine(removeBtn.getAttribute('data-key'), 0);
      return;
    }

    // qty steppers
    var up = t.closest('[data-qty-up]');
    var down = t.closest('[data-qty-down]');
    if (up || down) {
      handleQty(up || down, up ? 1 : -1);
      return;
    }

    // upsell add / cart-add variant
    var addVar = t.closest('[data-add-variant]');
    if (addVar && !addVar.disabled) {
      e.preventDefault();
      addToCart(addVar.getAttribute('data-add-variant'), 1, addVar);
      return;
    }

    // product card add-to-bag bar
    var quick = t.closest('[data-quick-add]');
    if (quick && quick.getAttribute('data-variant-id')) {
      e.preventDefault();
      addFromCard(quick);
      return;
    }

    // gift wrap toggle (cart attribute)
    var giftWrap = t.closest('[data-gift-wrap]');
    if (giftWrap) {
      e.preventDefault();
      var on = giftWrap.classList.toggle('is-on');
      giftWrap.setAttribute('aria-pressed', on);
      giftWrap.querySelector('span').textContent = on ? '✓' : '';
      postJSON('/cart/update.js', { attributes: { gift_wrap: on ? 'Yes' : 'No' } });
      return;
    }
  });

  // Esc closes drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- qty stepper: PDP is local, cart lines hit the API ---------- */
  function handleQty(btn, dir) {
    var key = btn.getAttribute('data-key');
    var wrap = btn.closest('[data-qty]');
    var valEl = wrap ? wrap.querySelector('[data-qty-value]') : null;
    if (!valEl) return;
    var current = parseInt(valEl.textContent, 10) || 1;
    var next = Math.max(key ? 0 : 1, current + dir);

    if (key) {
      changeLine(key, next);           // cart line
    } else {
      valEl.textContent = next;        // PDP local quantity
    }
  }

  function changeLine(key, quantity) {
    postJSON('/cart/change.js', { id: key, quantity: quantity })
      .then(function () { refreshDrawer(false); refreshCartPage(); });
  }

  function addToCart(variantId, qty, btn) {
    if (btn) { btn.disabled = true; }
    var label = btn ? btn.textContent : '';
    if (btn) btn.textContent = 'Adding…';
    return postJSON('/cart/add.js', { items: [{ id: variantId, quantity: qty || 1 }] })
      .then(function () { return refreshDrawer(true); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label || 'Add'; } })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label || 'Add'; } });
  }

  // Product-card add bar: keeps its label markup, flashes "Added ✓" on success.
  function addFromCard(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled) return;
    btn.disabled = true;
    postJSON('/cart/add.js', { items: [{ id: id, quantity: 1 }] })
      .then(function () { return refreshDrawer(true); })
      .then(function () {
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); btn.disabled = false; }, 1500);
      })
      .catch(function () { btn.disabled = false; });
  }

  // If we're on the full cart page, reload it after a change so totals update.
  function refreshCartPage() {
    if (document.querySelector('.cart-page')) {
      window.location.reload();
    }
  }

  /* ============================================================
     PRODUCT PAGE — variant selection + add to bag
     ============================================================ */
  function initProduct() {
    var form = $('[data-product-form]');
    var root = $('[data-product]');
    if (!form) return;

    var productData = null;
    if (root && root.getAttribute('data-product-json')) {
      try { productData = JSON.parse(root.getAttribute('data-product-json')); } catch (err) {}
    }

    var priceEl = $('[data-price]');
    var addPriceEl = $('[data-add-price]');
    var variantInput = $('[data-variant-input]');

    // Chip selection (both live + demo). Live products resolve to a variant.
    $$('.pdp__opt').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var chip = e.target.closest('.chip');
        if (!chip) return;
        $$('.chip', group).forEach(function (c) { c.classList.remove('is-selected'); });
        chip.classList.add('is-selected');
        if (productData) resolveVariant(productData, priceEl, addPriceEl, variantInput);
      });
    });

    // Add to bag
    form.addEventListener('submit', function (e) {
      if (!variantInput) { e.preventDefault(); return; } // demo: no-op
      e.preventDefault();
      var qty = parseInt(($('[data-qty-value]', form) || {}).textContent, 10) || 1;
      addToCart(variantInput.value, qty, $('[data-add-to-bag]', form));
    });

    // Thumbnail gallery
    $$('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        $$('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var mainImg = $('[data-main-image] img');
        var thumbImg = thumb.querySelector('img');
        if (mainImg && thumbImg) mainImg.src = thumbImg.src;
      });
    });
  }

  function resolveVariant(product, priceEl, addPriceEl, variantInput) {
    var selected = $$('.pdp__opt').map(function (group) {
      var chip = group.querySelector('.chip.is-selected');
      return chip ? chip.getAttribute('data-value') : null;
    });
    var match = (product.variants || []).find(function (v) {
      return selected.every(function (val, i) {
        return val == null || v.options[i] === val;
      });
    });
    if (!match) return;
    if (variantInput) variantInput.value = match.id;
    var money = formatVariantPrice(match.price);
    if (priceEl) priceEl.textContent = money;
    if (addPriceEl) addPriceEl.textContent = money;
  }

  function formatVariantPrice(cents) {
    // Shopify variant price is in cents. Format simply as AED.
    return formatMoney(cents / 100, 'AED');
  }

  /* ============================================================
     FREQUENTLY BOUGHT TOGETHER
     ============================================================ */
  function initFBT() {
    $$('[data-fbt]').forEach(function (fbt) {
      var discount = parseFloat(fbt.getAttribute('data-discount')) || 0;
      var currency = fbt.getAttribute('data-currency') || 'AED';
      var items = $$('[data-fbt-item]', fbt);

      function recompute() {
        var count = 0, sum = 0;
        items.forEach(function (item) {
          if (item.classList.contains('is-selected')) {
            count++;
            sum += parseFloat(item.getAttribute('data-price')) || 0;
          }
        });
        var discounted = sum * (1 - discount / 100);
        var countEl = $('[data-fbt-count]', fbt);
        var totalEl = $('[data-fbt-total]', fbt);
        var wasEl = $('[data-fbt-was]', fbt);
        if (countEl) countEl.textContent = count;
        if (totalEl) totalEl.textContent = count ? formatMoney(discounted, currency) : '—';
        if (wasEl) wasEl.textContent = (count && discount) ? formatMoney(sum, currency) : '';
      }

      items.forEach(function (item) {
        var toggle = $('[data-fbt-toggle]', item);
        if (!toggle) return;
        toggle.addEventListener('click', function () {
          var on = item.classList.toggle('is-selected');
          toggle.setAttribute('aria-pressed', on);
          var check = $('.fbt__check', item);
          if (check) check.textContent = on ? '✓' : '';
          recompute();
        });
      });

      var addBtn = $('[data-fbt-add]', fbt);
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var payload = items
            .filter(function (i) { return i.classList.contains('is-selected') && i.getAttribute('data-variant-id'); })
            .map(function (i) { return { id: i.getAttribute('data-variant-id'), quantity: 1 }; });
          if (!payload.length) { openDrawer(); return; } // demo mode
          addBtn.disabled = true;
          postJSON('/cart/add.js', { items: payload })
            .then(function () { return refreshDrawer(true); })
            .then(function () { addBtn.disabled = false; });
        });
      }

      recompute();
    });
  }

  /* ============================================================
     MAKE IT A GIFT — toggle add-ons (visual)
     ============================================================ */
  function initGiftOptions() {
    $$('[data-gift-opt]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var on = opt.classList.toggle('is-selected');
        opt.setAttribute('aria-pressed', on);
        var tog = $('.gift-opt__toggle', opt);
        if (tog) { tog.classList.toggle('is-on', on); tog.textContent = on ? '✓' : ''; }
      });
    });
  }

  /* ============================================================
     MOBILE NAV
     ============================================================ */
  function initMenu() {
    var toggle = $('[data-menu-toggle]');
    var nav = $('.site-nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      nav.style.display = open ? 'flex' : '';
    });
  }

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initProduct();
    initFBT();
    initGiftOptions();
    initMenu();
  });
})();